import { ref } from 'vue'

const STORAGE_KEY = 'admin_theme'

export const isDark = ref(false)

let clientInited = false

function readStored(): boolean {
  if (!import.meta.client) return false
  try {
    const s = localStorage.getItem(STORAGE_KEY)
    if (s === 'light') return false
    if (s === 'dark') return true
  } catch {
    /* ignore */
  }
  return false
}

function applyClass() {
  if (!import.meta.client) return
  const root = document.documentElement
  if (isDark.value) root.classList.add('dark')
  else root.classList.remove('dark')
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) meta.setAttribute('content', isDark.value ? '#050308' : '#f0ebe3')
}

export function useTheme() {
  function initTheme() {
    if (!import.meta.client || clientInited) return
    clientInited = true
    isDark.value = readStored()
    applyClass()
  }

  function toggleTheme() {
    isDark.value = !isDark.value
    if (import.meta.client) {
      try {
        localStorage.setItem(STORAGE_KEY, isDark.value ? 'dark' : 'light')
      } catch {
        /* ignore */
      }
    }
    applyClass()
  }

  return { isDark, initTheme, toggleTheme }
}
